import { translateWithFallback as t } from "./translateWithFallback";

type TranslatedText = { key: string; fallback: string };

type RejectionCopy = {
    /** The inline banner above the prefilled composer. */
    composeMessage: TranslatedText;
    /** The global toast, shown while the user is away from the builder. */
    toastMessage: TranslatedText;
};

/** One entry per `error_code` the agent rejects a prompt with. */
const REJECTION_COPY = new Map<string, RejectionCopy>([
    [
        "invalid_topic",
        {
            composeMessage: {
                key: "market.builder.v2.compose.rejection.invalidTopic",
                fallback: "This doesn't look like a market description. Try rephrasing it.",
            },
            toastMessage: {
                key: "market.builder.agentBanner.rejected.invalidTopic",
                fallback: "Not a market description",
            },
        },
    ],
    [
        "no_domains",
        {
            composeMessage: {
                key: "market.builder.v2.compose.rejection.noDomains",
                fallback: "Agent did not find enough websites for this description. Try rephrasing it.",
            },
            toastMessage: {
                key: "market.builder.agentBanner.rejected.noDomains",
                fallback: "Could not find any websites",
            },
        },
    ],
]);

/** For a code the agent sends before this client knows it. */
const UNKNOWN_REJECTION_COPY: RejectionCopy = {
    composeMessage: {
        key: "market.builder.v2.compose.rejection.unknown",
        fallback: "Agent could not build an industry from this description. Try rephrasing it.",
    },
    toastMessage: {
        key: "market.builder.agentBanner.rejected.unknown",
        fallback: "Could not build the industry",
    },
};

const copyFor = (errorCode: string | null): RejectionCopy =>
    (errorCode && REJECTION_COPY.get(errorCode)) || UNKNOWN_REJECTION_COPY;

export const getRejectionComposeMessage = (errorCode: string | null): string => {
    const { key, fallback } = copyFor(errorCode).composeMessage;
    return t(key, fallback);
};

export const getRejectionToastMessage = (errorCode: string | null): string => {
    const { key, fallback } = copyFor(errorCode).toastMessage;
    return t(key, fallback);
};
